import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  template: ''
})
export class BaseComponent implements OnDestroy {
  protected unSubscriber: Subject<any> = new Subject<any>();

  ngOnDestroy(): void {
    this.unSubscriber.next(null);
    this.unSubscriber.unsubscribe();
  }
}
